import { render, staticRenderFns } from "./PractitionerList.vue?vue&type=template&id=727b0b38"
import script from "./PractitionerList.vue?vue&type=script&lang=js"
export * from "./PractitionerList.vue?vue&type=script&lang=js"
import style0 from "./PractitionerList.vue?vue&type=style&index=0&id=727b0b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports